import Tooltip from 'components/common/tooltip/Tooltip';
import { Link } from 'react-router-dom';
import formatCurrency from 'utils/formatCurrency';
import formatNumber from 'utils/formatNumber';
import validateStatus from 'utils/validateStatus';
import Switch from 'components/common/switch/Switch';

function mailingPlanIdFormatter(cell, row) {
    const franchiseId = row.franchiseId;
    const mailingPlanId = row.id;
    const year = row?.year;
    const mailingStatus = row?.status

    if(String(cell).includes('customId')) {
        return (
            <span className='mailing-plan-link'></span>
        );
    }

    return (
        <Link 
            id='dashboard-table-row-mailing-plan-id'
            to={ mailingStatus == undefined || validateStatus.isDraft(mailingStatus)?`/mailing-plan/edit/${franchiseId}/${mailingPlanId}/${year}` : `/mailing-plan/${franchiseId}/${mailingPlanId}/${year}` }
            className='mailing-plan-link'
        >
            {cell || '-'}
        </Link>
    );
}

function investmentFormatter(cell, row) {
    if(isNaN(cell)) return cell;

    return `$${formatCurrency(Number(cell))}`;
}

function actionsFormatter(cell, row) {
    if(!row) return null;

    const franchiseId = row?.franchiseId;
    const year = row?.year || row?.yearFilter;

    return (
        <div id='dashboard-table-row-actions'>
            {
                validateStatus.isUnsubmitted(row?.status) &&
                    <Link
                        id='dashboard-table-row-action-create'
                        to={`/mailing-plan/create/${franchiseId}/${year}`}
                        className='create-plan-btn'
                    >
                        Create Plan
                    </Link>
            }
            {
                row.viewDetailsCallback && !validateStatus.isUnsubmitted(row?.status) &&
                    <Tooltip 
                        id='dashboard-table-row-action-summary'
                        icon='far fa-eye'
                        iconClassName='cursor-pointer'
                        message='View summary'
                        action={() => row.viewDetailsCallback(row)}
                    />
            }
        </div>
    );
}
function dmExemptFormatter(cell, row) {
    if(!row) return null;
    const mailingPlanId = row?.id;
    let isDmExempt = row?.isDmExempt;
    let label = isDmExempt ? "Yes" :"No";
        return (
            label
            );
}
function addressesFormatter(cell, row) {
    if(!cell) return '-';

    return formatNumber(cell);
}


const  mailingPlanColumns = [
    {
        title: 'Request ID',
        label: 'Request ID',
        dataIndex: 'id',        
        filterName: 'id',
        key: 'id',
        dataField: 'id',
        sorter: true,
        render: mailingPlanIdFormatter
    },
    {
        title: 'Request Status',
        label: 'Request Status',
        dataIndex: 'status',                
        filterName: 'status',
        key: 'status',
        dataField: 'status',
        sorter: true
    },
    {
        title: 'Franchise Name',
        label: 'Franchise Name',
        dataIndex: 'franchise',                
        filterName: 'franchise',
        key: 'franchise',
        dataField: 'franchise',
        sorter: true
    },
    {
        title: 'Submitted Date',
        label: 'Submitted Date',
        dataIndex: 'submittedDate',                
        filterName: 'submittedDate',
        key: 'submittedDate',
        dataField: 'submittedDate',
        sorter: true
    },
    {
        title: 'Modified Date',
        label: 'Modified Date',
        dataIndex: 'modifiedDate',                
        filterName: 'modifiedDate',
        key: 'modifiedDate',
        dataField: 'modifiedDate',
        sorter: true
    },
    {
        title: 'Investment',
        label: 'Investment',
        dataIndex: 'investment',                
        filterName: 'investment',
        key: 'investment',
        dataField: 'investment',
        sorter: true,
        render: investmentFormatter
    },
    {
        title: 'Total Addresses',
        label: 'Total Addresses',
        dataIndex: 'totalAddresses',                
        filterName: 'totalAddresses',
        key:  'totalAddresses',
        dataField: 'totalAddresses',
        sorter: true,
        render: addressesFormatter
    },
    {
        title: 'Actions',        
        dataIndex: 'actions',                
        filterName: 'actions',
        key:  'actions',
        dataField: 'actions',        
        render: actionsFormatter
    },
    {
        title: 'DM Exempt',
        label: 'DM Exempt',
        dataIndex: 'dmExempt',                
        filterName: 'dmExempt',
        key: 'dmExempt',
        dataField: 'dmExempt',
        sort: true,
        render: dmExemptFormatter
    }
];

export default mailingPlanColumns;